import { IIndicator, getInputLabelText } from "./../../achart/indicators";
import { Component, OnInit, ElementRef, Input, AfterViewInit } from "@angular/core";
import { NgbActiveModal, NgbModal, NgbModalRef, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { FormGroup, FormControl } from "@angular/forms";
import { getChartColorMap } from "../../achart/achart.colors";
import { ColorEvent } from "ngx-color";
import * as $ from "jquery";
import "malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.concat.min.js";
import * as ColorFn from "color";

@Component({
    selector: "indicatorModal",
    template: require('./IndicatorModal.component.html'),
    styles: [require('./IndicatorModal.component.scss')]
})
export class IndicatorModalComponent implements OnInit, AfterViewInit {
    indicator: IIndicator = {
        abbreviation: "",
        group: "",
        defaults: {
            item: []
        },
        title: "",
        type: "",
        description: ""
    };

    columnClass: string = "col-4";

    seriesType: string[] = [
        "area",
        "column",
        "jump-line",
        "line",
        "marker",
        "spline",
        "spline-area",
        "step-area",
        "step-line",
        "stick"
    ];

    indicatorValue: string[] = ["high", "low", "open", "close"];

    /*get indicatorHeights(): number[]{
        const heights: number[] = [];
        for(let i = 25; i <= 70; i+=5)
            heights.push(i);
        return heights; 
    }*/

    indicatorHeights = [25, 30, 35, 40, 45, 50, 55, 60, 65, 70];

    _selectedHeight: number = this.indicatorHeights[0];

    get selectedHeight() {
        return this._selectedHeight;
    }

    set selectedHeight(value: number) {
        if (this._selectedHeight == value) return;
        this.form.value["selectedHeight"] = this._selectedHeight = value;
    }

    showValueSelector: boolean = true;
    showPlotHeightSelector: boolean = true;

    @Input()
    form: FormGroup;
    colors: any = {};

    addOrUpdate: boolean = true;
    addToAllCharts: boolean = false;

    constructor(public activeModal: NgbActiveModal, protected element: ElementRef) {
        this.form = new FormGroup({});
    }

    initForm(
        indicator: IIndicator,
        addOrUpdate: boolean = true,
        plotHeight: number = 25,
        backgroundColor: string | undefined = undefined
    ) {
        this.indicator = indicator;
        this.addOrUpdate = addOrUpdate;
        let formControls: any = {};
        //debugger;
        this.indicator.defaults.item.forEach(v => {
            if (v.type == "string") {
                // serie type color/width/basedon....
                let ctrl = new FormControl();
                formControls[v.name] = ctrl; // type
                ctrl = new FormControl();
                formControls[`${v.name}_color`] = ctrl; // color
                ctrl = new FormControl();
                formControls[`${v.name}_width`] = ctrl; // width
            } else {
                let ctrl = new FormControl();
                formControls[v.name] = ctrl;
            }
            if (v.name == "plotIndex") {
                let pi = Number(v.value);
                pi = isNaN(pi) ? 0 : pi;
                this.showValueSelector = pi == 0;
                this.showPlotHeightSelector = pi > 0;
            }
        });

        formControls[`basedOn`] = new FormControl(); // basedOn
        formControls["addToAllCharts"] = new FormControl();
        formControls["selectedHeight"] = new FormControl();

        this.form = new FormGroup(formControls);
        let x: any = {};
        let colorIndex = 0;
        let colorMap = getChartColorMap();
        this.indicator.defaults.item.forEach(v => {
            if (v.type == "number") {
                x[v.name] = Number(v.value);
            } else if (v.type == "string") {
                x[v.name] = v.value; // type

                if (!v.color) {
                    v.color = colorMap[colorIndex][1];
                    colorIndex += 10;
                    v.width = 2;
                }
                if (this.isAreaSeries(v.name) && addOrUpdate) {
                    v.color = "rgba(0, 0, 0, 0)"; // full transparent
                } else {
                    var c = v.color;
                    if (addOrUpdate && backgroundColor) {
                        var cf = new ColorFn(v.color);
                        var cb = new ColorFn(backgroundColor);
                        if ((cb.isDark() && cf.isDark()) || (cb.isLight() && cf.isLight())) {
                            cf = cb.negate();
                        }
                        c = `rgba(${cf.red()},${cf.green()},${cf.blue()},${cf.alpha()})`;
                    }
                    v.color = c;
                }
                this.colors[v.name] = v.color;
                x[`${v.name}_color`] = v.color; // color
                x[`${v.name}_width`] = v.width; // line width
            } else if (v.type == "array") {
                let array: string[] = v.array || [""]; // JSON.parse(v.value);
                x[v.name] = v.value || array[0];
                v.array = array;
            }
        });

        x["basedOn"] = this.indicator.defaults.basedOn || "close";

        x["addToAllCharts"] = false;

        x["selectedHeight"] = isNaN(plotHeight) ? this.indicatorHeights[0] : plotHeight;

        this.form.setValue(x);
        // this.selectedHeight = isNaN(plotHeight) ? this.indicatorHeights[0] : plotHeight;

        // this.form.controls["selectedHeight"].setValue(this.selectedHeight, { onlySelf: true });
    }

    public colorFixChange: { [index: string]: string } = {};

    colorStrokeChange($event: ColorEvent, field: string, fieldName: string): void {
        let f = this.indicator.defaults.item.filter(v => v.name == field);
        if (f.length > 0) {
            const colorCssString = `rgba(${$event.color.rgb.r},${$event.color.rgb.g},${$event.color.rgb.b},${
                $event.color.rgb.a
            })`;
            f[0].color = colorCssString;
            this.form.value[fieldName] = colorCssString;
            this.colorFixChange[fieldName] = colorCssString;
        }
    }

    addToAllChartsClick() {
        this.addToAllCharts = !this.addToAllCharts;
        this.form.value["addToAllCharts"] = this.addToAllCharts;
    }

    isAreaSeries(seriesName: string): boolean {
        var seriesToSkipSelectors: string[] = ["rangeseriestype"];
        return seriesToSkipSelectors.indexOf(seriesName.toLowerCase()) >= 0;
    }

    ngOnInit() {}

    ngAfterViewInit(): void {
        $(this.element.nativeElement)
            .find(".raised-bg")
            .hide();
        $(this.element.nativeElement)
            .find(".swatches-picker")
            .css("width", "220px");
        $(this.element.nativeElement)
            .find(".swatches-overflow")
            .mCustomScrollbar(<any>{
                axis: "y",
                theme: "inset-3",
                scrollbarPosition: "outside",
                alwaysShowScrollbar: 1,
                scrollButtons: {
                    enable: true
                },
                advanced: {
                    autoExpandHorizontalScroll: true
                },
                mouseWheel: {
                    enable: true
                },
                scrollInertia: 150,
                updateOnContentResize: true
            });

        /**hide.bs doesnt work  */
        $(this.element.nativeElement)
            .find(".swatchclick")
            .on("click", function(e: any) {
                var target = $(e.target);
                if (target.attr("class") != "swatch") {
                    e.stopPropagation();
                }
            });
    }

    getInputLabelText(key: string) {
        return getInputLabelText(key);
    }

    compare(v1: any, v2: any): boolean {
        return v1 == v2;
    }
}
